import { TrackingAction, TrackingServiceStatus } from '@/types/device'

export const DEFAULT_TRACKING_STATUS: TrackingServiceStatus = 'not_installed'

export const TRACKING_SERVICE_STATUSES: TrackingServiceStatus[] = [
  'not_installed',
  'installing',
  'running',
  'stopped',
  'updating',
  'failed'
]

export const TRACKING_BUSY_STATUSES: TrackingServiceStatus[] = [
  'installing',
  'updating'
]

// Start, stop and restart finish within one poll, so they need no optimistic status.
const OPTIMISTIC_STATUS_BY_ACTION: Partial<
  Record<TrackingAction, TrackingServiceStatus>
> = {
  install: 'installing',
  update: 'updating'
}

// Minutes, not Tower's seconds: an install pulls an image and a model and builds an engine.
export const OPTIMISTIC_STATUS_TIMEOUT_MS = 120000

export const isKnownTrackingStatus = (
  status: string
): status is TrackingServiceStatus => {
  return TRACKING_SERVICE_STATUSES.some((known) => known === status)
}

export const isTrackingBusyStatus = (status: TrackingServiceStatus) => {
  return TRACKING_BUSY_STATUSES.includes(status)
}

/** A status this build has never heard of is work in progress, not a state to act on. */
export const isTrackingInProgress = (status: string) => {
  return !isKnownTrackingStatus(status) || isTrackingBusyStatus(status)
}

export const optimisticStatusForAction = (action: TrackingAction) => {
  return OPTIMISTIC_STATUS_BY_ACTION[action] ?? null
}

export const shouldClearOptimisticStatus = (
  reported: string,
  reportedWhenSet: string
) => {
  return reported !== reportedWhenSet
}
